import { getPlatformType, isDianpingAppOrWebview, isMeituanAppOrWebview, isWeixinMiniProgramOrWeixinWebview, PlatformType } from '@nibfe/mkt-env-api';
import { navigateTo } from "@max/meituan-uni-navigate";
import { reportJSInfo } from '@max/meituan-uni-report';
export const productMap = {
    trip_deal: 1,
    trip_poi: 2,
    trip_hotel_spu: 3,
    // 周边游SPU
    hotel_poi: 4,
    food_poi: 5,
    super_spu_multi_coupon: 6,
    // 超团多poi通兑券
    coupon_package: 7,
    // 券包，后端已使用
    oversea_poi: 8,
    mbox_sku: 9,
    food_deal: 10,
    // 到餐deal
    super_spu_single_package: 11,
    // 超团单poi套餐
    shuffle: 12,
    // 混排货架,
    joy_poi: 13,
    // 休闲娱乐
    beauty_poi: 14,
    // 丽人
    wedding_poi: 15 // 婚礼poi
};
function getFormattedDate(daysOffset) {
    const date = new Date();
    date.setDate(date.getDate() + daysOffset);
    const year = date.getFullYear();
    let month = date.getMonth() + 1;
    month = month < 10 ? '0' + month : month;
    let day = date.getDate();
    day = day < 10 ? '0' + day : day;
    return `${year}-${month}-${day}`;
}
const jumpToPage = (url, params) => {
    navigateTo({
        url: url,
        _web: {
            miniProgramNative: true
        },
        _ext: {
            mrnProgram: {
                params
            },
            options: {
                extraArgs: {}
            }
        }
    }).then(res => { }).catch(error => {
        reportJSInfo({
            secCategory: 'jsError',
            level: 'info',
            content: 'mcp-tex-comprehensive-card onJump 出错',
            tags: {
                errorInfo: JSON.stringify(error)
            }
        });
    });
};
const convertLinkToAppMiddleOpenLink = (url) => {
    return `https://m.dianping.com/awp/hfe/block-page/call-native/meituan.html?url=${encodeURIComponent(url)}`;
};
const getMaxPoiDetailSwitch = () => {
    const search = location.search.slice(1);
    const params = new URLSearchParams(search);
    const maxPoiDetailSwitch = params.get('maxPoiDetailSwitch');
    console.log('maxPoiDetailSwitch', maxPoiDetailSwitch);
    return maxPoiDetailSwitch === 'true';
};
function isValidPoiId(poiId) {
    if (typeof poiId !== 'string') {
        console.warn('The poiid obtained by the isValidPoiId method is not a string type.error poiid:', poiId);
    }
    const poiIdStr = String(poiId !== null && poiId !== void 0 ? poiId : '');
    return !(['', '0', 'null', 'NULL'].includes(poiIdStr) || poiIdStr.startsWith('-'));
}
function addUrlParams(params) {
    var _a, _b, _c;
    return (_c = (_b = (_a = Object === null || Object === void 0 ? void 0 : Object.entries(params)) === null || _a === void 0 ? void 0 : _a.filter(([_, value]) => value != null && value !== '' && value !== undefined)) === null || _b === void 0 ? void 0 : _b.map(([key, value]) => `${key}=${String(value)}`)) === null || _c === void 0 ? void 0 : _c.join('&');
}
export const onNavigate = (product, query, systemInfo, poiIdListString, poiIdUrlExtraParamsString) => {
    const { productType, productIdStr, extInfo } = product;
    const { poiIdStr, shopUuid, shopIdStr } = extInfo || {};
    const { hotelchannel } = query || {};
    // poiId升级
    // poiId、productId字段废弃，新增字段为poiIdStr、productIdStr
    const productId = productIdStr && isValidPoiId(productIdStr) ? productIdStr : '';
    const poiId = poiIdStr && isValidPoiId(poiIdStr) ? poiIdStr : '';
    // @ts-ignore
    if (!productId || (window === null || window === void 0 ? void 0 : window.inEditor)) {
        return;
    }
    if (productType == productMap.trip_deal) {
        const invokeLink = `imeituan://www.meituan.com/mrn?mrn_biz=travel&mrn_entry=traveldealdetail&mrn_component=ticketdealdetail&${addUrlParams({
            dealId: productId,
            hotelchannel
        })}`;
        if (isMeituanAppOrWebview()) {
            jumpToPage(invokeLink);
        }
        else if (isDianpingAppOrWebview()) {
            jumpToPage(`dianping://htmrn?mrn_biz=travel&mrn_entry=traveldealdetail&mrn_component=ticketdealdetail&${addUrlParams({
                dealId: productId,
                hotelchannel
            })}`);
        }
        else if (isWeixinMiniProgramOrWeixinWebview()) {
            return;
        }
        else {
            jumpToPage(convertLinkToAppMiddleOpenLink(invokeLink));
        }
        return;
    }
    if (productType === productMap.trip_poi) {
        const invokeLink = `imeituan://www.meituan.com/htmrn?mrn_biz=travel&mrn_entry=travelcore&mrn_component=poidetail&${addUrlParams({
            poiId: productId,
            shopuuid: shopUuid,
            hotelchannel
        })}`;
        if (isMeituanAppOrWebview()) {
            jumpToPage(invokeLink);
        }
        else if (isDianpingAppOrWebview()) {
            jumpToPage(`dianping://htmrn?mrn_biz=travel&mrn_entry=travelcore&mrn_component=poidetail&${addUrlParams({
                poiId: productId,
                shopuuid: shopUuid,
                hotelchannel
            })}`);
        }
        else if (isWeixinMiniProgramOrWeixinWebview()) {
            return;
        }
        else {
            jumpToPage(invokeLink);
        }
        return;
    }
    if (productType === productMap.trip_hotel_spu) {
        const { locationCityId, selectCityId } = query || {};
        const cityId = Number(locationCityId) || Number(selectCityId) || 1;
        let checkInDate = '';
        if (extInfo === null || extInfo === void 0 ? void 0 : extInfo.checkInTime) {
            const checkInTimeDate = new Date(extInfo.checkInTime * 1000);
            const year = checkInTimeDate.getFullYear();
            let month = checkInTimeDate.getMonth() + 1;
            month = month < 10 ? '0' + month : month;
            let day = checkInTimeDate.getDate();
            day = day < 10 ? '0' + day : day;
            checkInDate = `${year}-${month}-${day}`;
        }
        const mrnParams = {
            cityId,
            id: poiId,
            spuId: productId,
            checkInDate,
            shopuuid: shopUuid,
            hotelchannel
        };
        if (isMeituanAppOrWebview()) {
            const baseUrl = `imeituan://www.meituan.com/mrn?mrn_biz=hotel&mrn_entry=tour-around-detail&mrn_component=tour-around-detail`;
            jumpToPage(`${baseUrl}&${addUrlParams(mrnParams)}`);
            return;
        }
        else if (isDianpingAppOrWebview()) {
            const baseUrl = `dianping://mrn?mrn_biz=hotel&mrn_entry=tour-around-detail&mrn_component=tour-around-detail`;
            jumpToPage(`${baseUrl}&${addUrlParams(mrnParams)}`);
            return;
        }
        else if (isWeixinMiniProgramOrWeixinWebview()) {
            const wxQuery = {
                poiId,
                spuId: productId,
                page_source: 'PaaS_mcp-tex-comprehensive-card',
                hotelchannel
            };
            jumpToPage(`/pages/tourAround/index?${addUrlParams(wxQuery)}`);
            return;
        }
        else {
            const invokeLink = convertLinkToAppMiddleOpenLink(`imeituan://www.meituan.com/mrn?mrn_biz=hotel&mrn_entry=tour-around-detail&mrn_component=tour-around-detail&${addUrlParams(mrnParams)}`);
            jumpToPage(invokeLink);
        }
    }
    if (productType === productMap.hotel_poi) {
        const checkInDate = getFormattedDate(0);
        const checkOutDate = getFormattedDate(1);
        if (isMeituanAppOrWebview()) {
            const baseUrl = 'imeituan://www.meituan.com/hotel/poi?mrn_biz=hotel&mrn_entry=rn-hotel-poidetail&mrn_component=hotel-poidetail';
            let mrnUrl = `${baseUrl}&${addUrlParams({
                id: productId,
                hotelchannel,
                checkInDate,
                checkOutDate
            })}`;
            if (poiIdListString && poiIdUrlExtraParamsString && (poiIdListString === null || poiIdListString === void 0 ? void 0 : poiIdListString.indexOf(productId)) > -1) {
                mrnUrl = `${mrnUrl}&${poiIdUrlExtraParamsString}`;
            }
            jumpToPage(mrnUrl);
            return;
        }
        else if (isDianpingAppOrWebview()) {
            const baseUrl = `dianping://shopinfo`;
            if (!shopUuid) {
                return;
            }
            jumpToPage(`${baseUrl}?${addUrlParams({
                shopuuid: shopUuid,
                hotelchannel,
                checkInDate,
                checkOutDate
            })}`);
            return;
        }
        else if (isWeixinMiniProgramOrWeixinWebview()) {
            const platformType = getPlatformType();
            switch (platformType) {
                case PlatformType.mtMinaWebview:
                    jumpToPage(`${getMaxPoiDetailSwitch() ? '/max-poi-detail/pages/poidetail/index' : '/hotel/pages/poi/pages/index/index'}?poiId=${productId}`);
                case PlatformType.mtHotelMinaWebview:
                    jumpToPage(`${getMaxPoiDetailSwitch() ? '/max-poi-detail/pages/poidetail/index' : '/pages/poi/pages/index/index'}?poiId=${productId}`);
                case PlatformType.dpMinaWebview:
                    jumpToPage(`/packages/hotel/pages/poi/pages/index/index?${addUrlParams({
                        shopId: shopIdStr,
                        shopUuid
                    })})`);
                default:
                    const invokeLink = convertLinkToAppMiddleOpenLink(`imeituan://www.meituan.com/mrn?mrn_biz=hotel&mrn_entry=rn-hotel-poidetail&mrn_component=hotel-poidetail&${addUrlParams({
                        id: productId,
                        hotelchannel,
                        checkInDate,
                        checkOutDate
                    })}`);
                    jumpToPage(invokeLink);
            }
        }
        else {
            const invokeLink = convertLinkToAppMiddleOpenLink(`imeituan://www.meituan.com/mrn?mrn_biz=hotel&mrn_entry=rn-hotel-poidetail&mrn_component=hotel-poidetail&${addUrlParams({
                id: productId,
                hotelchannel,
                checkInDate,
                checkOutDate
            })}`);
            jumpToPage(invokeLink);
        }
    }
    if (productType === productMap.food_poi) {
        const invokeLink = `imeituan://www.meituan.com/food/poi/detail?${addUrlParams({
            id: productId,
            shopuuid: productId,
            hotelchannel
        })}`;
        if (isMeituanAppOrWebview()) {
            jumpToPage(invokeLink);
        }
        else if (isDianpingAppOrWebview()) {
            jumpToPage(`dianping://shopinfo?${addUrlParams({
                shopuuid: productId,
                hotelchannel
            })}`);
        }
        else if (isWeixinMiniProgramOrWeixinWebview()) {
            const platformType = getPlatformType();
            switch (platformType) {
                case PlatformType.mtMinaWebview:
                    jumpToPage(`mt/pages/food/poi?id=${productId}`);
                case PlatformType.dpMinaWebview:
                    jumpToPage(`/pages/poi/poi?shopUuid=${productId}`);
                default:
                    jumpToPage(convertLinkToAppMiddleOpenLink(invokeLink));
            }
        }
        else {
            jumpToPage(convertLinkToAppMiddleOpenLink(invokeLink));
        }
        return;
    }
    if (productType === productMap.food_deal) {
        const params = {
            channel: 'food',
            deal_id: productId,
            did: productId,
            productId
        };
        const defaultUrl = `imeituan://www.meituan.com/food/deal?${addUrlParams(params)}`;
        if (isMeituanAppOrWebview()) {
            jumpToPage(defaultUrl);
        }
        else if (isDianpingAppOrWebview()) {
            jumpToPage(`dianping://fooddealdetail?${addUrlParams(params)}`);
        }
        else if (isWeixinMiniProgramOrWeixinWebview()) {
            const platformType = getPlatformType();
            switch (platformType) {
                case PlatformType.mtMinaWebview:
                    jumpToPage(`/food/pages/mt/deal/deal?dealId=${productId}`);
                case PlatformType.dpMinaWebview:
                    jumpToPage(`/packages/msdeal/pages/deal-detail/deal-detail?dealGroupId=${productId}`);
                default:
                    jumpToPage(convertLinkToAppMiddleOpenLink(`imeituan://www.meituan.com/food/deal?${addUrlParams(params)}`));
            }
        }
        else {
            jumpToPage(convertLinkToAppMiddleOpenLink(`imeituan://www.meituan.com/food/deal?${addUrlParams(params)}`));
        }
        return;
    }
    if (productType === productMap.super_spu_multi_coupon || productType === productMap.super_spu_single_package) {
        const mrnParams = {
            mboxCouponId: extInfo === null || extInfo === void 0 ? void 0 : extInfo.mboxCouponId,
            poiId,
            spuId: productId,
            hotelchannel
        };
        const invokeLink = `imeituan://www.meituan.com/mrn?mrn_biz=hotel&mrn_entry=superdeal&mrn_component=superdeal&${addUrlParams(mrnParams)}}`;
        if (isMeituanAppOrWebview()) {
            const baseUrl = 'imeituan://www.meituan.com/mrn?mrn_biz=hotel&mrn_entry=superdeal&mrn_component=superdeal';
            jumpToPage(`${baseUrl}&${addUrlParams(mrnParams)}`);
            return;
        }
        else if (isDianpingAppOrWebview()) {
            const baseUrl = `dianping://mrn?mrn_biz=hotel&mrn_entry=superdeal&mrn_component=superdeal`;
            jumpToPage(`${baseUrl}&${addUrlParams(mrnParams)}`);
            return;
        }
        else if (isWeixinMiniProgramOrWeixinWebview()) {
            const platformType = getPlatformType();
            switch (platformType) {
                case PlatformType.mtMinaWebview:
                    jumpToPage(`/hotel/pages/superGroup/index?spuId=${productId}&poiId=${poiId}&mboxCouponId=${extInfo === null || extInfo === void 0 ? void 0 : extInfo.mboxCouponId}`);
                    break;
                case PlatformType.mtHotelMinaWebview:
                    jumpToPage(`/pages/superGroup/index?spuId=${productId}&poiId=${poiId}&mboxCouponId=${extInfo === null || extInfo === void 0 ? void 0 : extInfo.mboxCouponId}`);
                    break;
                default:
                    jumpToPage(convertLinkToAppMiddleOpenLink(invokeLink));
                    break;
            }
        }
        else {
            jumpToPage(convertLinkToAppMiddleOpenLink(invokeLink));
        }
    }
    if (productType === productMap.oversea_poi) {
        const defaultUrl = `imeituan://www.meituan.com/overseahotel/poi?${addUrlParams({
            poiId: productId
        })}`;
        if (isMeituanAppOrWebview()) {
            jumpToPage(defaultUrl);
        }
        else if (isDianpingAppOrWebview()) {
            jumpToPage(`dianping://shopinfo?${addUrlParams({
                shopuuid: shopUuid
            })}`);
        }
        else if (isWeixinMiniProgramOrWeixinWebview()) {
            const platformType = getPlatformType();
            switch (platformType) {
                case PlatformType.mtMinaWebview:
                    jumpToPage(`/oversea-hotel/pages/poi-detail-webview/index?poiId=${productId}`);
                    break;
                case PlatformType.mtHotelMinaWebview:
                    jumpToPage(`/pkg/oversea/pages/poi-detail-webview/index?poiId=${productId}`);
                    break;
                case PlatformType.dpMinaWebview:
                    jumpToPage(`/packages/oversea-hotel/pages/poi-detail-webview/index?poiId=${productId}`);
                    break;
                default:
                    jumpToPage(convertLinkToAppMiddleOpenLink(`imeituan://www.meituan.com/overseahotel/poi?${addUrlParams({
                        poiId: productId
                    })}`));
                    break;
            }
        }
        else {
            jumpToPage(convertLinkToAppMiddleOpenLink(`imeituan://www.meituan.com/overseahotel/poi?${addUrlParams({
                poiId: productId
            })}`));
            return;
        }
    }
    if (productType === productMap.mbox_sku) {
        jumpToPage(`http://i.meituan.com/awp/h5/marketsale/home/index.html?id=${productId}&channel=100`);
    }
    if (productType === productMap.joy_poi) {
        const mrnParams = {
            id: productId,
            showType: 'entertainment',
            shopid: productId
        };
        const invokeLink = `imeituan://www.meituan.com/gc/mrn?mrn_biz=gcbu&mrn_entry=mrn-joy-poidetail&mrn_component=poidetail&${addUrlParams(mrnParams)}`;
        if (isMeituanAppOrWebview()) {
            jumpToPage(invokeLink);
        }
        else if (isDianpingAppOrWebview()) {
            jumpToPage(`dianping://gcmrn?mrn_biz=gcbu&mrn_entry=mrn-joy-poidetail&mrn_component=poidetail&${addUrlParams(Object.assign(Object.assign({}, mrnParams), { id: productIdStr, shopuuid: shopUuid, shopid: shopIdStr }))}`);
        }
        else if (isWeixinMiniProgramOrWeixinWebview()) {
            return;
        }
        else {
            jumpToPage(convertLinkToAppMiddleOpenLink(`imeituan://www.meituan.com/gc/mrn?mrn_biz=gcbu&mrn_entry=mrn-joy-poidetail&mrn_component=poidetail&${addUrlParams(mrnParams)}`));
        }
        return;
    }
    if (productType === productMap.beauty_poi) {
        const mrnParams = {
            id: productId,
            poiid: productId,
            showType: 'beauty',
            shopid: productId
        };
        const defaultUrl = `imeituan://www.meituan.com/gc/mrn?mrn_biz=gcbu&mrn_entry=mrn-beauty-poidetail&mrn_component=poidetail`;
        if (isMeituanAppOrWebview()) {
            jumpToPage(`${defaultUrl}&${addUrlParams(mrnParams)}`);
        }
        else if (isDianpingAppOrWebview()) {
            jumpToPage(`dianping://gcmrn?mrn_biz=gcbu&mrn_entry=mrn-beauty-poidetail&mrn_component=poidetail&${addUrlParams(Object.assign(Object.assign({}, mrnParams), { id: productIdStr, shopuuid: shopUuid, shopid: shopIdStr }))}`);
        }
        else if (isWeixinMiniProgramOrWeixinWebview()) {
            return;
        }
        else {
            jumpToPage(convertLinkToAppMiddleOpenLink(`${defaultUrl}&${addUrlParams(mrnParams)}`));
        }
        return;
    }
    if (productType === productMap.wedding_poi) {
        const mrnParams = {
            id: productId,
            poiid: productId,
            showType: 'married',
            shopid: productId
        };
        const invokeLink = `imeituan://www.meituan.com/gc/mrn?mrn_biz=gcbu&mrn_entry=mrn-beauty-poidetail&mrn_component=poidetail&${addUrlParams(mrnParams)}`;
        if (isMeituanAppOrWebview()) {
            jumpToPage(invokeLink);
        }
        else if (isDianpingAppOrWebview()) {
            jumpToPage(`dianping://gcmrn?mrn_biz=gcbu&mrn_entry=mrn-beauty-poidetail&mrn_component=poidetail&${addUrlParams(Object.assign(Object.assign({}, mrnParams), { id: productIdStr, shopuuid: shopUuid, shopid: shopIdStr }))}`);
        }
        else if (isWeixinMiniProgramOrWeixinWebview()) {
            return;
        }
        else {
            jumpToPage(convertLinkToAppMiddleOpenLink(invokeLink));
        }
        return;
    }
};
